import type { Channel } from '../api'
import { PenIcon, VerticalVideoIcon, WideVideoIcon } from './icons'

const ICONS = { short: VerticalVideoIcon, youtube: WideVideoIcon, linkedin: PenIcon }

/** The glyph for a channel: a tall frame, a wide frame, or a pen. */
export function ChannelIcon({ channel, size = 16 }: { channel: Channel; size?: number }) {
  const Icon = ICONS[channel]
  return <Icon size={size} className="channel-icon" data-channel={channel} />
}
